export { TeachingPopoverTitle } from './TeachingPopoverTitle';
export { useTeachingPopoverTitle } from './useTeachingPopoverTitle';
export { renderTeachingPopoverTitle } from './renderTeachingPopoverTitle';
export type {
  TeachingPopoverTitleProps,
  TeachingPopoverTitleSlots,
  TeachingPopoverTitleState,
} from './TeachingPopoverTitle.types';
